import { useState } from 'react';

export const useRTEState = () => {
  const [bookmarkStatus, setBookmarkStatus] = useState({ isBookmarked: false });
  const [recipientType, setRecipientType] = useState(false);
  const [prevBookmarkStatus, setPrevBookmarkStatus] = useState({ isBookmarked: false });

  return {
    bookmarkStatus,
    setBookmarkStatus,
    recipientType,
    setRecipientType,
    prevBookmarkStatus,
    setPrevBookmarkStatus,
    recipientValue: recipientType ? 'PCP' : null,
  };
};
